import { defineMessages, useIntl } from 'react-intl';

import {
  ClearIndicator,
  customSelectStyles,
  DropdownIndicator,
  Option,
  selectTheme,
} from '@plone/volto/components/manage/Widgets/SelectStyling';
import cx from 'classnames';
import Select from 'react-select';
import { Form, Grid, Label } from 'semantic-ui-react';
const messages = defineMessages({
  select: {
    id: 'Select…',
    defaultMessage: 'Select…',
  },
  labelRequiredField: {
    id: 'label-required-field',
    defaultMessage: 'Required field',
  },
});

export const SelectField = ({
  label,
  field,
  options,
  disabled = false,
  errorMessage,
  required = false,
}: {
  label: string;
  field: string;
  options: { label: string; value: string }[];
  disabled?: boolean;
  errorMessage?: string;
  required?: boolean;
}) => {
  const intl = useIntl();
  return (
    <Form.Field inline className={cx('help', required && 'required')}>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column computer={4} mobile={12}>
            <div className="wrapper">
              <label htmlFor={field}>
                {label}&nbsp;
                {required && (
                  <span className="label-required">
                    ({intl.formatMessage(messages.labelRequiredField)})
                  </span>
                )}
              </label>
            </div>
          </Grid.Column>
          <Grid.Column computer={8} mobile={12}>
            <Select
              id={field}
              key={options}
              name={field}
              menuShouldScrollIntoView={false}
              isSearchable={true}
              className="react-select-container"
              classNamePrefix="react-select"
              options={options}
              styles={customSelectStyles}
              theme={selectTheme}
              components={{
                DropdownIndicator,
                ClearIndicator,
                Option,
              }}
              required={required}
              isDisabled={disabled}
              placeholder={intl.formatMessage(messages.select)}
              isClearable
            />
            {errorMessage && (
              <Label
                key={errorMessage}
                basic
                color="red"
                className="form-error-label"
              >
                {errorMessage}
              </Label>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form.Field>
  );
};
